import { vmodule, VueModule } from '@niknevis/vue-modules'
import UserService from '@/modules/user/services/user.service'


declare module 'vue/types/vue' {
  interface Vue {
    User: UserService
  }
}

@vmodule()
export default class UserModule extends VueModule {
  readonly name = 'UserModule'

  components = [
    () => import('./Layout.vue') //important to load panel
  ]

  services = {
    User: UserService
  }
}
